import { HttpEventType, HttpResponse } from "@angular/common/http"
import { BehaviorSubject, Subscription } from "rxjs"
import { finalize } from "rxjs/operators"
import { TransferHttpService } from "src/app/services/transfer-http/transfer-http.service"

export class FileUploader {
  uploadProgress: number = null
  uploadSub: Subscription

  constructor(private transferHttp: TransferHttpService) {
  }

  public uploadFiles(files: FileList, saveUrl: string, progressSubject: BehaviorSubject<number> = null) {
    if (files.length == 0) {
      console.log('No file selected!')
      return
    }

    progressSubject.next(0);
    let file: File = files[0]

    const formData = new FormData()
    formData.append('Files', file)

    const upload$ = this.transferHttp
      .post(saveUrl, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(finalize(() => this.reset()))

    this.uploadSub = upload$.subscribe(
      (event) => {
        if (event.type == HttpEventType.UploadProgress) {
          if (progressSubject) {
            this.uploadProgress = Math.round(100 * (event.loaded / event.total))
            progressSubject.next(this.uploadProgress);
            // console.log(`File is ${this.uploadProgress}% loaded.`)
          }
        } else if (event instanceof HttpResponse) {
          progressSubject.next(100);
        }
      },
      (err) => {
        console.log('Upload Error:', err)
      }
    )
  }

  cancelUpload() {
    this.uploadSub?.unsubscribe()
    this.reset()
  }

  reset() {
  }
}
